require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/$.core').Array.from;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/from.js
// module id = 289
// module chunks = 0